import type { FC, ReactNode } from 'react'

import { FACTS } from '@/constants/content'

export const ReferenceSection: FC = (): ReactNode => {
    return (
        <section
            id='referenzen'
            aria-labelledby='referenzen-title'
            className='relative isolate overflow-hidden bg-primary py-20 text-primary-foreground sm:py-24'
        >
            <div
                aria-hidden='true'
                className='pointer-events-none absolute inset-0 -z-10 bg-grid-inverted opacity-60 [mask-image:radial-gradient(ellipse_70%_90%_at_0%_50%,black,transparent_80%)]'
            />

            <div className='mx-auto grid max-w-6xl gap-12 px-6 lg:grid-cols-12 lg:items-center lg:gap-10'>
                <div className='lg:col-span-5'>
                    <p className='flex items-center gap-3 font-mono text-[0.72rem] font-medium uppercase tracking-[0.2em] text-primary-foreground/75'>
                        <span className='h-px w-6 bg-current' aria-hidden='true' />
                        Im Einsatz
                    </p>

                    <h2 id='referenzen-title' className='mt-6 flex items-end gap-5'>
                        <span className='text-[6.5rem] font-extralight leading-[0.8] tracking-[-0.05em] sm:text-[8rem]'>
                            7
                        </span>

                        <span className='pb-1 text-2xl font-light leading-tight sm:text-[1.75rem]'>
                            überwachte Bodenplatten
                            <span className='block text-primary-foreground/75'>
                                für zwei Bauunternehmen, 2026
                            </span>
                        </span>
                    </h2>

                    <p className='mt-8 max-w-md text-pretty leading-relaxed text-primary-foreground/80'>
                        ConcreTrack ist auf echten Baustellen im Einsatz. Die wichtigsten Eckdaten aus dem Messalltag:
                    </p>
                </div>

                <dl className='grid gap-4 sm:grid-cols-2 lg:col-span-7'>
                    {FACTS.map((fact) => (
                        <div key={fact.value} className='reveal flex flex-col-reverse justify-end gap-2 rounded-[1.5rem] border border-white/15 bg-white/[0.06] p-6'>
                            <dt className='text-pretty text-[0.95rem] leading-relaxed text-primary-foreground/80'>
                                {fact.label}
                            </dt>

                            <dd className='text-3xl font-light tracking-[-0.02em] sm:text-[2.1rem]'>
                                {fact.value}
                            </dd>
                        </div>
                    ))}
                </dl>
            </div>
        </section>
    )
}
